import moment from 'moment-timezone';
import requestService from 'viralstyle-ui/src/requestService';
import storage from 'viralstyle-ui/src/storage';
import hateoas from 'viralstyle-ui/src/hateoas';

import router from '@/router';
import config from 'config';

let pendingTokenPromise = null;

export const async = async ({ commit, dispatch, state }, promise) => {
  let promiseObj = {
    id: state.promiseCount,
    promise: promise(),
  };

  commit('addPromise', promiseObj);

  try {
    let response = await promiseObj.promise;

    commit('removePromise', promiseObj);

    return response;
  } catch (error) {
    commit('removePromise', promiseObj);

    // only log the error if its not an invalid login, no need to flood sentry with bad login attempts
    if (error.requiresLogin) {

      // if token is invalid, get a new one, wait for it to come back and then rerun the request
      // TODO probably have to handle logging out a logged in user here
      if (!pendingTokenPromise) {
        pendingTokenPromise = dispatch('getPublicToken');
      }

      await pendingTokenPromise;

      pendingTokenPromise = null;

      dispatch('logout', true);

      return dispatch('async', promise);

      // silently fail
    } else {
      let errorData = await dispatch('logError', error);

      // set this flag so on the global exception catch all, we dont log this
      error.logged = true;

      if (errorData) {
        error.data = errorData;
      }
    }

    throw error;
  }
};

export const getSiteConfig = async ({ state, getters, dispatch, commit }) => {
  let response = await dispatch('get', hateoas.url('get_whitelabel_domain_configs', { domain: getters.domain }));

  commit('updateState', { object: state, property: 'domainConfig', value: response.data });

  return response;
};

export const getCollections = async ({ state, getters, dispatch, commit }) => {
  let response = await dispatch('get', `${hateoas.url('search_whitelabel_collections', { domain: getters.domain })}?sort=stores.created_at:DESC`);

  commit('updateState', { object: state, property: 'collections', value: response.data._embedded.items });

  return response;
};

export const getPublicToken = async ({ dispatch }) => {
  return dispatch('async', () => requestService.get(`${config.APP_PROTOCOL}:${config.API_URL}${config.API_ROOT}/v3/token`, false));
};

export const getCurrencyInfo = async ({ state, dispatch, commit }, country) => {
  let url = hateoas.url('get_customer_currency');

  if (country) {
    url += `?country_iso=${country}`
  }

  let response = await dispatch('get', url);

  commit('updateState', {
    object: state,
    property: 'currencyInfo',
    value: response.data,
  });

  if (!country) {
    commit('updateState', {
      object: state.checkout.customer,
      property: 'country',
      value: state.currencyInfo.country_iso,
    });
  }

  return response;
};

export const navigateToRecentCampaignOrMarketplace = ({}, doNotReplace) => {
  let recentCampaign = storage.get('recent-campaign');

  if (recentCampaign) {
    doNotReplace ? router.push({ name: 'sales', params: { ...recentCampaign } }) : router.replace({ name: 'sales', params: { ...recentCampaign } });
  } else {
    doNotReplace ? router.push({ name: 'home' }) : router.replace({ name: 'home' });
  }
};

export const campaignFallbackOrMarketplace = ({ dispatch }, { replace, campaignFallback }) => {
  if (campaignFallback) {
    dispatch('navigateToRecentCampaignOrMarketplace', !replace);
  } else {
    replace ? router.push({ name: 'home' }) : router.replace({ name: 'home' });
  }
};

export const navigateToLastListing = ({ dispatch }, { replace = false, campaignFallback = false } = { replace: false, campaignFallback: false }) => {
  let lastListing = storage.get('last-listing-url');

  if (lastListing) {
    let duration = moment.duration(moment().diff(lastListing.time)),
      hours = duration.asHours();

    if (hours <= 24) {
      replace ? router.replace(lastListing.url) : router.push(lastListing.url);
    } else {
      storage.remove('last-listing-url');

      dispatch('campaignFallbackOrMarketplace', { replace, campaignFallback })
    }
  } else {
    dispatch('campaignFallbackOrMarketplace', { replace, campaignFallback })
  }
};